import {IUsersContextState} from "./UsersContext.interfaces";
import {ITeamsContext} from "services/TeamsContext/TeamsContext.interfaces";
import {useCallback, useEffect, useState} from "react";
import {GraphService} from "../GraphService";
import {IUser} from "../../Interfaces/IUser";

const initialState: IUsersContextState = {
    list: new Array<IUser>(),
    loaded: false,
    currentUser: undefined,
    isFetchingDataFromParent: false,
}

export const useUserContext = (teamsContext: ITeamsContext) => {
    const [state, setState] = useState<IUsersContextState>(initialState);

    useEffect(function onMount() {
        (async () => {
            if (!teamsContext.loaded) return;
            await fetchCurrentUser(teamsContext.userId);
        })()
    }, [teamsContext.loaded]);

    const fetchCurrentUser = useCallback(async (userId: string) => {
        if (!teamsContext.loaded) return;
        const data = await GraphService.getUsersDataAsync([userId]);
        if (data.length === 0) throw new Error("Can't get current user profile data");
        setState((prevState): IUsersContextState => ({
            ...prevState,
            currentUser: data[0],
            loaded: true,
        }));
    }, [teamsContext.loaded]);

    const fetchUsers = useCallback(async (usersIds: Array<string>) => {
        if (!teamsContext.loaded) return [];
        const ids = Array.from(new Set<string>(usersIds));
        const users = await GraphService.getUsersDataAsync(ids);
        setState((prevState): IUsersContextState => {
            const newList = [...prevState.list];
            const prevUsersIds = prevState.list.map(u => u.id);
            users.forEach(u => !prevUsersIds.includes(u.id) && newList.push(u));
            return {
                ...prevState,
                list: newList,
            }
        });
        return users;
    }, [teamsContext.loaded]);

    return {
        ...state,
        fetchUsers,
    }
}